// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"380011e8","703":"ee62f358","787":"14ed968d"}[chunkId] + ".chunk.js";
};